import { jsx } from "react/jsx-runtime";
import MortgageRatesSummary from "./MortgageRatesSummary.esm.js";
const MortgageRatesSummaryBlock = {
  Component: ({
    attrs
  }) => {
    const {
      pathname = "/mortgage-rates/"
    } = attrs;
    return /* @__PURE__ */ jsx(MortgageRatesSummary, { ...{
      pathname
    } });
  },
  metadata: {
    version: "1.0",
    name: "constellation/mortgage-rates-summary",
    title: "Mortgage Rates Summary",
    description: "A summary of today's mortgage rates.",
    icon: "businessperson",
    keywords: ["mortgages", "calculators", "rates"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Layout",
    attributes: {
      pathname: {
        type: "string",
        label: "Path",
        default: "/mortgage-rates/",
        control: "text"
      }
    }
  }
};
export {
  MortgageRatesSummaryBlock as default
};
